// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cdId: __t.u64().primaryKey().name("cd_id"),
  bankId: __t.u64().name("bank_id"),
  identity: __t.identity(),
  principal: __t.i64(),
  rateBps: __t.f64().name("rate_bps"),
  termDays: __t.u32().name("term_days"),
  openedAt: __t.timestamp().name("opened_at"),
  maturesAt: __t.timestamp().name("matures_at"),
});
